(function () {
  if (window.AdegaCollectionConfettiLoaded) {
    if (typeof window.AdegaSetupCollectionConfetti === 'function') {
      window.AdegaSetupCollectionConfetti();
    }
    return;
  }

  window.AdegaCollectionConfettiLoaded = true;

  const CONFETTI_COLORS = ['#f5a811', '#d84f6f', '#7bdff2', '#b2f7ef', '#f7f06d', '#c77dff', '#1a3240'];
  const CLEANUP_DELAY = 3000;

  function getCanvasConfetti(src) {
    if (typeof window.AdegaCanvasConfetti === 'function') {
      return Promise.resolve(window.AdegaCanvasConfetti);
    }

    if (window.AdegaCanvasConfettiLoader) {
      return window.AdegaCanvasConfettiLoader;
    }

    window.AdegaCanvasConfettiLoader = new Promise(function (resolve, reject) {
      const script = document.createElement('script');

      script.src = src;
      script.async = true;
      script.dataset.adegaCanvasConfetti = 'true';
      script.onload = function () {
        if (typeof window.confetti !== 'function') {
          reject(new Error('canvas-confetti did not expose window.confetti'));
          return;
        }

        window.AdegaCanvasConfetti = window.confetti;
        resolve(window.AdegaCanvasConfetti);
      };
      script.onerror = reject;

      document.head.appendChild(script);
    });

    return window.AdegaCanvasConfettiLoader;
  }

  function fireMobileCelebrationPreset(canvasConfetti, commonOptions) {
    const count = 600;
    const defaults = {
      ...commonOptions,
      origin: { y: .7 }
    };

    function fire(particleRatio, options) {
      canvasConfetti({
        ...defaults,
        ...options,
        particleCount: Math.floor(count * particleRatio)
      });
    }

    fire(.25, {
      spread: 26,
      startVelocity: 55
    });
    fire(.2, {
      spread: 60
    });
    fire(.35, {
      spread: 100,
      decay: .91,
      scalar: .8
    });
    fire(.1, {
      spread: 120,
      startVelocity: 25,
      decay: .92,
      scalar: 1.2
    });
    fire(.1, {
      spread: 120,
      startVelocity: 45
    });
  }

  function fireDesktopWidePreset(canvasConfetti, commonOptions) {
    const count = 600;

    function fire(particleRatio, options) {
      canvasConfetti({
        ...commonOptions,
        ...options,
        particleCount: Math.floor(count * particleRatio)
      });
    }

    fire(.22, {
      spread: 80,
      startVelocity: 55,
      origin: { x: .12, y: .7 },
      angle: 60
    });
    fire(.22, {
      spread: 80,
      startVelocity: 55,
      origin: { x: .88, y: .7 },
      angle: 120
    });
    fire(.26, {
      spread: 140,
      decay: .91,
      scalar: .85,
      origin: { x: .5, y: .68 }
    });
    fire(.15, {
      spread: 180,
      startVelocity: 32,
      decay: .92,
      scalar: 1.05,
      origin: { x: .28, y: .72 }
    });
    fire(.15, {
      spread: 180,
      startVelocity: 32,
      decay: .92,
      scalar: 1.05,
      origin: { x: .72, y: .72 }
    });
  }

  function startConfetti(root, canvasConfetti) {
    const commonOptions = {
      zIndex: 2147483646,
      disableForReducedMotion: true,
      colors: CONFETTI_COLORS
    };

    root.dataset.started = 'true';

    if (window.innerWidth < 768) {
      fireMobileCelebrationPreset(canvasConfetti, commonOptions);
    } else {
      fireDesktopWidePreset(canvasConfetti, commonOptions);
    }

    window.setTimeout(function () {
      root.hidden = true;
      root.dataset.started = 'false';
    }, CLEANUP_DELAY);
  }

  function scheduleConfetti(root) {
    window.setTimeout(function () {
      getCanvasConfetti(root.dataset.confettiSrc)
        .then(function (canvasConfetti) {
          startConfetti(root, canvasConfetti);
        })
        .catch(function () {
          root.remove();
        });
    }, 250);
  }

  function setupRoot(root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    if (root.dataset.started === 'true' || !root.dataset.confettiSrc) {
      root.remove();
      return;
    }

    if (document.readyState === 'complete') {
      scheduleConfetti(root);
    } else {
      window.addEventListener('load', function () {
        scheduleConfetti(root);
      }, { once: true });
    }

    window.addEventListener('pageshow', function (event) {
      if (event.persisted && root.dataset.started !== 'true') {
        scheduleConfetti(root);
      }
    });
  }

  function setupCollectionConfetti() {
    document.querySelectorAll('[data-collection-confetti]').forEach(setupRoot);
  }

  window.AdegaSetupCollectionConfetti = setupCollectionConfetti;

  setupCollectionConfetti();
  document.addEventListener('shopify:section:load', setupCollectionConfetti);
})();
